import { jsxs as a, jsx as l } from "react/jsx-runtime";
import * as n from "react";
import { cn as m } from "../../../lib/utils.js";
const o = n.forwardRef(({ className: r, label: t, error: e, helperText: s, required: c, children: d, ...i }, x) => a("div", { ref: x, className: m("w-full space-y-1.5", r), ...i, children: [t && a("label", { className: "block text-sm font-medium text-text-primary", children: [t, c && l("span", { className: "text-lpr-red ml-1", children: "*" })] }), d, (e || s) && l("p", { className: m("text-xs", e ? "text-lpr-red" : "text-text-secondary"), children: e || s })] }));
o.displayName = "Field";
export {
  o as Field
};
//# sourceMappingURL=Field.js.map
